import { fanchaData, jiudianData, wanghongData } from "./categoryData";

export interface ArticleDetail {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  time: string;
  views: string;
  heroImage: string;
  contentImage: string;
  summary: string;
  content: string[];
  quote: string;
  quoteAuthor: string;
  tags: string[];
}

export const wanghongArticles: ArticleDetail[] = [
  {
    id: "wh-1",
    title: "百万粉丝美妆博主被扒黑历史，品牌方集体解约",
    category: "网红翻车",
    categorySlug: "wanghong",
    time: "1小时前",
    views: "56.8万",
    heroImage: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20vanity%20table%20with%20scattered%20makeup%20products%2C%20cracked%20mirror%2C%20dim%20warm%20lighting%2C%20abandoned%20beauty%20studio%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20deep%20shadows&width=1600&height=800&seq=detail-wh1-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Makeup%20products%20scattered%20on%20dark%20vanity%20table%2C%20cracked%20mirror%2C%20dim%20dramatic%20lighting%2C%20abandoned%20beauty%20studio%2C%20warm%20atmospheric%20mood%2C%20editorial%20photography%2C%20deep%20shadows&width=800&height=1000&seq=detail-wh1-content&orientation=portrait",
    summary: "曾凭借一手精湛化妆技术吸粉百万的美妆博主@甜心美妆酱，近日被同行曝光其早期视频造假、产品测评收钱推广不标注等一系列黑料。多个知名美妆品牌紧急宣布终止合作，其社交账号一夜掉粉30万，引发全网热议。",
    content: [
      "据知情人士透露，@甜心美妆酱 在2019年至2023年间，通过购买假粉、刷量等手段快速积累粉丝基数。其早期的多个爆款化妆教程视频，实际上是经后期剪辑拼接而成，所谓的素颜到妆前妆后效果对比存在严重造假行为。",
      "更令人震惊的是，该博主在长达三年的时间内，与其签约的MCN机构合谋收取品牌方高额推广费用，但在视频中故意不标注广告标识，涉嫌违反《广告法》相关规定。据不完全统计，涉及合作的品牌超过40家，未标注广告的视频数量高达120余条。",
      "事件曝光后，知名国货美妆品牌花西子、完美日记、橘朵等已第一时间发布声明，宣布终止与该博主的所有商业合作，并将追究其违约责任。花西子品牌方在声明中表示：我们坚决维护消费者知情权，对任何试图欺骗消费者的行为零容忍。",
      "该博主随后发布道歉视频，但态度敷衍、避重就轻的回应反而激怒了更多粉丝。视频下方评论区被愤怒的网友攻陷，24小时内掉粉超过30万。其背后的MCN机构也被推上风口浪尖，被指是整个造假链条的始作俑者。",
      "目前，市场监管部门已介入调查此事。业内专家指出，这起事件暴露了网红经济行业长期存在的监管漏洞，呼吁相关部门尽快出台更严格的网红营销规范。",
    ],
    quote: "她曾经是美妆圈的标杆，是无数女孩心中的化妆导师。但当信任崩塌的那一刻，所有精致的妆容都掩盖不了赤裸裸的欺骗。这不是一个人的翻车，是整个行业的照妖镜。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["美妆博主", "翻车现场", "广告造假", "品牌解约"],
  },
  {
    id: "wh-2",
    title: "搞笑段子手人设崩塌，私信骚扰多名女粉丝被曝光",
    category: "网红翻车",
    categorySlug: "wanghong",
    time: "3小时前",
    views: "12.8万",
    heroImage: "https://readdy.ai/api/search-image?query=Dark%20room%20with%20a%20smartphone%20screen%20glowing%2C%20scattered%20papers%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20amber%20light%20from%20phone%2C%20editorial%20photography&width=1600&height=800&seq=detail-wh2-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Anonymous%20figure%20silhouette%20in%20dark%20room%20holding%20phone%2C%20dramatic%20backlighting%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20editorial%20portrait&width=800&height=1000&seq=detail-wh2-content&orientation=portrait",
    summary: "以幽默搞笑内容走红的男博主@笑点低先生，近日被多名女粉丝联合曝光长期利用私信功能进行言语骚扰，甚至在对方明确拒绝后仍然持续骚扰，行为恶劣引发众怒。",
    content: [
      "据悉，@笑点低先生 在短视频平台拥有超过80万粉丝，以其接地气的幽默风格著称。然而在光鲜人设背后，多名女性粉丝晒出了大量私信截图，内容包含了大量不当言论和骚扰性话语。",
      "最早站出来发声的是网名为@小太阳 的女粉丝。她表示自己在2024年初曾在直播间打赏后被该博主主动私信搭讪，起初以为是正常的粉丝互动，但对方很快转变话题，开始发送大量带有性暗示的信息。在她明确表示不适后，对方不仅没有收敛，反而变本加厉。",
      "随着@小太阳 的发声，更多的女性受害者纷纷站了出来。截至目前，已有超过15名女性公开了自己被该博主骚扰的经历，时间跨度从2023年至2026年。多位受害者表示，该博主会利用自己在粉丝中的影响力，让对方不敢轻易举报或公开此事。",
      "事件发酵后，该博主所在的短视频平台已将其账号暂时封禁处理，并表示将对此事进行深入调查。但截至发稿前，该博主尚未对此事做出任何公开回应。",
    ],
    quote: "搞笑的背后不该是龌龊，粉丝的喜爱更不是骚扰的通行证。人设崩塌不可怕，可怕的是崩塌后露出的那副让人作呕的真面目。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["搞笑博主", "私信骚扰", "粉丝举报", "账号封禁"],
  },
  {
    id: "wh-3",
    title: "健身博主被揭使用特效滤镜造假身材，真实照片流出",
    category: "网红翻车",
    categorySlug: "wanghong",
    time: "6小时前",
    views: "9.5万",
    heroImage: "https://readdy.ai/api/search-image?query=Dark%20gym%20with%20single%20spotlight%20on%20empty%20workout%20area%2C%20abandoned%20weights%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20composition&width=1600&height=800&seq=detail-wh3-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Broken%20mirror%20in%20dark%20gym%2C%20scattered%20fitness%20equipment%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography&width=800&height=1000&seq=detail-wh3-content&orientation=portrait",
    summary: "健身博主@铁血硬汉 被粉丝实锤其所有训练视频和照片均使用身体特效滤镜处理，实际体型与展示效果相差巨大。其售卖的健身课程也被指效果造假。",
    content: [
      "拥有50万粉丝的健身博主@铁血硬汉 一直以其八块腹肌和壮硕肌肉走红，并通过售卖线上健身课程赚得盆满钵满。然而近日，有技术达人粉丝对其视频进行了逐帧分析，发现其使用的身体特效滤镜可以实时改变肌肉线条和体型比例。",
      "一位不愿透露姓名的健身教练匿名向本台提供了该博主在健身房被偷拍的真实照片。照片中的@铁血硬汉 与视频中的形象差异巨大——没有所谓的八块腹肌，手臂围度也大打折扣，完全是一个普通人的身材。该教练称这些照片拍摄于2025年11月，地点在广州某商业健身房。",
      "更有购买了其线上课程的学员站出来抱怨，按照课程锻炼了半年没有任何效果。有学员质疑称：他自己都没有练出来的身材，凭什么卖课教别人？",
      "面对铺天盖地的质疑，@铁血硬汉 在沉默了两天后发布了一条声明，声称自己只是使用了美颜滤镜，爱美之心人皆有之。但这种说法显然没能平息众怒，评论区一片嘲讽。",
    ],
    quote: "一个连自己都没练出肌肉的人，却靠卖健身课赚了几百万。这大概就是流量时代最讽刺的黑色幽默——真假不重要，能骗到钱就行。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["健身博主", "特效滤镜", "身材造假", "健身课程"],
  },
];

export const fanchaArticles: ArticleDetail[] = [
  {
    id: "fc-1",
    title: "清纯女神深夜酒吧视频曝光，与白天判若两人",
    category: "反差视频",
    categorySlug: "fancha",
    time: "4小时前",
    views: "38.2万",
    heroImage: "https://readdy.ai/api/search-image?query=Split%20scene%20contrast%2C%20left%20bright%20day%20garden%20peaceful%2C%20right%20dark%20nightclub%20neon%20lights%2C%20conceptual%20duality%2C%20cinematic%20composition&width=1600&height=800&seq=detail-fc1-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Two%20contrasting%20scenes%20split%20diagonally%2C%20upper%20bright%20day%20garden%20peaceful%2C%20lower%20dark%20nightclub%20neon%20lights%2C%20conceptual%20duality%20photography&width=800&height=1000&seq=detail-fc1-content&orientation=portrait",
    summary: "以清纯甜美形象走红的小花旦@纯纯兔兔，白天直播时温柔可人岁月静好，却被拍到深夜在酒吧与多名男性亲密互动，与平日形象截然不同。粉丝直呼：这反差也太大了吧！",
    content: [
      "在抖音拥有200万粉丝的@纯纯兔兔，凭借甜美的长相和温柔的嗓音走红。她的直播内容通常是弹弹吉他、唱唱小清新歌曲，偶尔聊聊日常生活，被粉丝亲切地称为邻家清纯女神。然而，近日流出的几段视频彻底颠覆了这一人设。",
      "据爆料人提供的视频显示，@纯纯兔兔 在2025年圣诞节深夜出现在上海某知名酒吧，身着性感短裙，妆容浓艳，与几名不明身份男性举止亲密，频频举杯畅饮。视频中她的状态与直播时判若两人，如果不是爆料人标注了具体时间地点，粉丝们几乎不敢相信这是同一人。",
      "更令人震惊的是，视频中还拍到她与其中一名男性在酒吧角落长时间拥吻的画面。而就在同一天的白天，她还在直播中对粉丝说自己在家里宅着看书，不喜欢热闹的地方。",
      "视频曝光后，@纯纯兔兔 的社交账号评论区瞬间炸锅。大量粉丝表示被欺骗，纷纷脱粉。有粉丝痛心留言：我追了你两年，每天看你直播，结果你在酒吧搂着别人？",
      "截至目前，该博主仍未对此事做出任何回应，其账号已设置为仅允许互关好友评论。",
    ],
    quote: "白天的清纯与夜晚的狂野，哪一面才是真正的她？也许两面都是，也许两面都不是。唯一确定的是，那些为她刷礼物的粉丝，此刻都成了这场闹剧中最心碎的看客。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["清纯女神", "酒吧视频", "人设反查", "深夜"],
  },
  {
    id: "fc-2",
    title: "正能量博主私下脏话连篇，直播忘关麦全录下来了",
    category: "反差视频",
    categorySlug: "fancha",
    time: "2小时前",
    views: "25.6万",
    heroImage: "https://readdy.ai/api/search-image?query=Dark%20studio%20with%20microphone%20on%20desk%2C%20red%20record%20light%20glowing%2C%20empty%20chair%2C%20dramatic%20atmosphere%2C%20cinematic%20style&width=1600&height=800&seq=detail-fc2-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Professional%20microphone%20on%20dark%20desk%2C%20recording%20studio%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography&width=800&height=1000&seq=detail-fc2-content&orientation=portrait",
    summary: "以正能量励志内容著称的博主@阳光哥 ，在一次直播结束后忘记关闭麦克风，随后长达15分钟的私密对话被全程直播，内容与其人设严重不符。",
    content: [
      "这大概是年度最尴尬的翻车现场了。拥有30万粉丝的正能量博主@阳光哥，日常发布的内容都是励志语录、人生感悟、正能量鸡汤，被粉丝称为互联网清流。然而这一切，在一次直播事故中彻底崩塌了。",
      "据观看直播的粉丝描述，当天@阳光哥 完成了一小时的常规直播后，宣布下播。但他显然忘记关闭麦克风。在随后的15分钟里，全直播间近2万在线粉丝听到了他和助理的对话——充斥着脏话、对粉丝的嘲讽以及对其他博主的恶毒评论。",
      "一位当时在线的粉丝截图了部分对话内容：这些粉丝就是傻X，随便说两句鸡汤就感动得不行……那个XX博主就是个抄袭狗，早晚找人搞他……。这些言论与其镜头前温文尔雅的形象形成了巨大反差。",
      "虽然@阳光哥 在事发后迅速发布了道歉声明，声称自己当时只是说了气话，并非本意。但大部分粉丝并不买账，认为这才是他的真实面目。截至目前，其粉丝数已从30万骤降至18万。",
    ],
    quote: "一个卖正能量人设的人，私下却对粉丝满口蔑视。这大概就是互联网最荒诞的一幕——镜头前的温暖与镜头后的冰冷，只隔着一个忘记关掉的麦克风。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["正能量博主", "直播事故", "忘关麦", "人设崩塌"],
  },
  {
    id: "fc-3",
    title: "节俭人设博主豪宅曝光，月租18万的顶层公寓引争议",
    category: "反差视频",
    categorySlug: "fancha",
    time: "5小时前",
    views: "18.9万",
    heroImage: "https://readdy.ai/api/search-image?query=Luxury%20penthouse%20living%20room%20at%20night%20with%20city%20skyline%20view%2C%20minimalist%20modern%20design%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20architectural%20photography&width=1600&height=800&seq=detail-fc3-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Luxury%20penthouse%20interior%20with%20floor%20to%20ceiling%20windows%2C%20modern%20minimalist%20furniture%2C%20city%20view%2C%20warm%20atmospheric%20lighting&width=800&height=1000&seq=detail-fc3-content&orientation=portrait",
    summary: "以节俭生活方式吸粉的博主@抠门小能手，日常穿着几十块的衣服、用着平价护肤品，却被人扒出其居住在上海陆家嘴月租18万的顶层公寓，奢侈生活与节俭人设严重不符。",
    content: [
      "@抠门小能手 靠着分享省钱技巧吸粉40万，她的视频里总是穿着几十块的T恤，用着十几块的护肤品，去菜市场讨价还价，被人称为全网最接地气的省钱博主。",
      "然而近日，一位自称是其前室友的网友在社交平台爆料，@抠门小能手 实际居住在上海陆家嘴金融区的一处顶层公寓，月租金高达18万人民币。该网友还附上了多张公寓内部的照片——落地窗俯瞰黄浦江、全屋定制家具、私人影音室……处处透露着奢华。",
      "消息一出，粉丝们炸开了锅。一位粉丝留言：我看她视频省吃俭用攒了半年钱，结果她自己住18万的顶层公寓？还有人挖出她近年来的大额消费记录，包括价值40万的爱马仕包包和多辆豪车。",
      "面对质疑，@抠门小能手 发文回应称自己住好房子和工作内容不冲突，并指责网友嫉妒她的成功。但这种傲慢态度再次激怒了粉丝，话题#抠门小能手翻车#迅速登上热搜。",
    ],
    quote: "一个教别人省钱的人，自己却过着月花几十万的奢侈生活。这已经不是反差了，这是赤裸裸的欺骗。你的节俭是谎言，而粉丝的信任很贵。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["节俭博主", "豪宅曝光", "奢侈生活", "人设崩塌"],
  },
];

export const jiudianArticles: ArticleDetail[] = [
  {
    id: "jd-1",
    title: "知名导演与女演员酒店密会48小时，实锤照片首曝光",
    category: "酒店猛料",
    categorySlug: "jiudian",
    time: "2小时前",
    views: "89.2万",
    heroImage: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20at%20night%20with%20dramatic%20lighting%2C%20rain-soaked%20street%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20cinematic%20photography&width=1600&height=800&seq=detail-jd1-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20room%20door%20slightly%20open%2C%20warm%20light%20spilling%20into%20dark%20corridor%2C%20mysterious%20atmosphere%2C%20noir%20style&width=800&height=1000&seq=detail-jd1-content&orientation=portrait",
    summary: "据前线吃瓜记者独家拍摄，某知名导演与旗下女演员在某五星级酒店连续密会长达48小时。期间二人多次同进同出，举止亲密。消息人士透露，该导演正在筹备的新戏女主角已内定该演员，引发剧组其他成员不满。",
    content: [
      "本台记者经过长达两个月的跟踪调查，终于拍到了某知名导演张某与旗下女演员李某在某五星级酒店密会的实锤照片。据酒店工作人员透露，二人以商务洽谈为名，在总统套房内连续逗留超过48小时。",
      "我们的记者在酒店大堂、电梯间、地下车库等多个地点拍到了二人同框照片。照片显示两人多次同进同出，张某多次搂着李某的腰部，行为举止远超普通工作关系。尤其是深夜时分，二人从地下车库直接乘坐VIP电梯到达总统套房楼层，避开了所有公共区域。",
      "消息人士向本台透露，张某目前正在筹备一部投资过亿的古装大戏，女主角已经内定为李某。这一决定在剧组内部引发了强烈不满，多位工作人员私下表示，李某的演技和经验远不足以担纲女主角。一位不愿透露姓名的工作人员称：大家都心知肚明，但没人敢说。",
      "有法律人士指出，如果上述行为涉及权色交易，将严重违反行业规范和职业道德，甚至可能触犯相关法律法规。目前，该导演和女演员均未对此事做出回应。",
      "业内资深制片人称，娱乐圈存在类似的潜规则早已不是秘密，但近年来随着舆论监督的加强和行业整顿的深入，这种情况正在改善。希望有关部门能够进一步加大监管力度，还娱乐圈一个清朗的环境。",
    ],
    quote: "一场48小时的酒店密会，一个早已内定的女主角。当权力和资源成为交换的筹码，演技和实力就成了最不值钱的东西。这出戏，台下比台上精彩多了。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["导演", "女演员", "酒店密会", "潜规则", "五星酒店"],
  },
  {
    id: "jd-2",
    title: "顶流小生与经纪人酒店开房被拍，回应称只是对剧本",
    category: "酒店猛料",
    categorySlug: "jiudian",
    time: "1小时前",
    views: "56.3万",
    heroImage: "https://readdy.ai/api/search-image?query=Hotel%20corridor%20at%20night%20with%20dim%20lighting%2C%20two%20room%20doors%2C%20mysterious%20atmosphere%2C%20noir%20cinematic%20style%2C%20editorial%20photography&width=1600&height=800&seq=detail-jd2-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Hotel%20room%20door%20with%20do%20not%20disturb%20sign%2C%20corridor%20lighting%2C%20mysterious%20atmosphere%2C%20film%20noir%20style&width=800&height=1000&seq=detail-jd2-content&orientation=portrait",
    summary: "当红小生王某被拍到深夜与年轻女经纪人一同进入酒店房间，凌晨两点才分别离开。经纪公司火速回应称二人只是在房间对剧本，但网友对此解释并不买账。",
    content: [
      "当红流量小生王某日前在横店拍摄新剧期间，被八卦媒体拍到与一名年轻女性深夜同回酒店。据蹲守记者描述，二人于晚上11点先后进入酒店，随后一同进入同一间房间，直至凌晨2点才先后离开。",
      "照片中可以看到，王某与该女性在电梯内举止亲密，进入房间后房间窗帘紧闭。直到凌晨2点15分左右，该女性先从房间出来，大约10分钟后王某才离开房间，似乎是在刻意错开时间。",
      "经核实，该女性为王某的个人执行经纪人，现年26岁，比王某大两岁。消息曝光后，王某所在经纪公司火速发表声明，称二人只是在房间内讨论第二天要拍的剧本，希望大家不要过度解读。",
      "然而网友对此解释并不买账。不少网友调侃：深夜对剧本，这也算是娱乐圈独创的加班方式了。还有网友翻出了此前多位明星用过类似借口的翻车案例，直呼这套说辞已经听腻了。",
      "目前，王某的粉丝后援会已经组织控评，但话题#王某深夜对剧本#仍然持续发酵，阅读量已突破3亿。",
    ],
    quote: "深夜酒店对剧本——这大概是娱乐圈最经典的危机公关模板。从十年前用到现在，从未更新，也从不真诚。对剧本需要关灯拉窗帘，这剧本怕不是盲文版的。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["顶流小生", "经纪人", "酒店", "对剧本"],
  },
  {
    id: "jd-3",
    title: "豪门千金婚前单身派对酒店狂欢，画面尺度惊人",
    category: "酒店猛料",
    categorySlug: "jiudian",
    time: "3小时前",
    views: "42.1万",
    heroImage: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20ballroom%20after%20party%2C%20scattered%20champagne%20glasses%2C%20confetti%20on%20floor%2C%20dim%20lighting%2C%20abandoned%20party%20scene&width=1600&height=800&seq=detail-jd3-hero&orientation=landscape",
    contentImage: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20suite%20after%20party%2C%20scattered%20champagne%2C%20messy%20room%2C%20warm%20lighting%2C%20editorial%20photography&width=800&height=1000&seq=detail-jd3-content&orientation=portrait",
    summary: "某知名房地产企业千金在婚前单身派对上包下五星酒店总统套房，派对场面奢华且尺度惊人。现场照片流出后引发巨大争议，男方家庭据悉非常不满。",
    content: [
      "近日，一组某知名房地产企业千金林某婚前单身派对的现场照片在网络上疯传。据悉，派对在上海外滩某五星级酒店的总统套房内举行，一晚消费据说超过50万人民币。",
      "从流出照片来看，派对上不仅有大量名酒美食，还邀请了多名男性模特现场助兴。照片中可以看到林某与模特之间的互动尺度相当大胆，多位在场的宾客用手机拍摄了大量照片和视频，这些内容随后通过各种渠道流出。",
      "据悉，林某原定于下个月与另一位企业家之子举行婚礼。男方家庭在看到了这些照片后据说非常不满，目前婚礼是否如期进行尚不明朗。有消息称，两家人已多次进行闭门会谈。",
      "这起事件也引发了网友对豪门婚姻的热议。有网友评论：婚前派对玩这么疯，让男方家脸往哪放？也有网友认为这是私人派对，不该被公开传播。但目前舆论对林某普遍不利。",
    ],
    quote: "一场50万的婚前派对，可能毁掉一场千万级的豪门联姻。在社交媒体时代，没有真正的隐私，只有被传播和不被传播的区别。这位千金大概现在才真正明白这个道理。",
    quoteAuthor: "51吃瓜前线记者",
    tags: ["豪门千金", "单身派对", "五星酒店", "婚前风波"],
  },
];

export function getArticleByCategoryAndId(category: string, id: string): ArticleDetail | undefined {
  const map: Record<string, ArticleDetail[]> = {
    wanghong: wanghongArticles,
    fancha: fanchaArticles,
    jiudian: jiudianArticles,
  };
  const existingArticle = map[category]?.find((a) => a.id === id);

  if (existingArticle) {
    return existingArticle;
  }

  const categoryMap: Record<string, typeof wanghongData> = {
    wanghong: wanghongData,
    fancha: fanchaData,
    jiudian: jiudianData,
  };
  const categoryData = categoryMap[category];
  const summaryArticle = categoryData?.articles.find((a) => a.id === id);

  if (!categoryData || !summaryArticle) {
    return undefined;
  }

  return {
    id: summaryArticle.id,
    title: summaryArticle.title,
    category: categoryData.title,
    categorySlug: category,
    time: summaryArticle.time,
    views: summaryArticle.views,
    heroImage: categoryData.heroImage,
    contentImage: categoryData.featuredArticle.image,
    summary: `${summaryArticle.title}，51每日大赛编辑部持续追踪事件进展，整理当前公开线索和频道内最新反馈。`,
    content: [
      `${summaryArticle.title} 目前仍在持续发酵，频道编辑会结合公开信息、网友反馈和后续回应进行整理更新。`,
      categoryData.description,
      "更多同类内容会在完成基础核实后同步到对应频道，方便读者集中查看最新进展。",
    ],
    quote: "热点从来不是孤立片段，真正有价值的是持续追踪、交叉验证和完整还原。",
    quoteAuthor: "51每日大赛编辑部",
    tags: [categoryData.title, "每日大赛", "实时追踪"],
  };
}

export function getRelatedArticles(category: string, excludeId: string): ArticleDetail[] {
  const map: Record<string, ArticleDetail[]> = {
    wanghong: wanghongArticles,
    fancha: fanchaArticles,
    jiudian: jiudianArticles,
  };
  return (map[category] || []).filter((a) => a.id !== excludeId);
}
